import React from 'react';
import { Show, ShowProps, SimpleShowLayout, TextField } from 'react-admin';
import { LimitedPartnerShowActions } from '../LimitedPartnerShowActions';
import { LimitedPartnerType } from '../../api';
import { useLocationState } from "../../location/useLocationState";

export const LimitedPartnerPersonShow: React.FC<ShowProps> = (
  props: ShowProps
) => {
  const location = useLocationState();
  const companyId = location.state.record.companyId;

  return (
    <Show
      {...props}
      actions={
        <LimitedPartnerShowActions
          companyId={companyId}
          variant={LimitedPartnerType.NaturalPerson}
        />
      }
      title='Limited partner'
    >
      <SimpleShowLayout>
        <TextField source='email' label='Email' />
        <TextField source='firstName' label='First name' />
        <TextField source='lastName' label='Last name' />
        <TextField source='residency' label='Residency' />
        <TextField source='amlStatus' label='AML Status' />
        <TextField source='veriffStatus' label='Veriff Status' />
      </SimpleShowLayout>
    </Show>
  );
};
